import ZapbookContainer from 'app/zapbook/components/ZapbookContainer';
import { createLandingPageRoute } from 'app/track/utils/TrackUtils';
import { mapDocumentToAppPickerProps } from 'app/zapbook/utils/extractors';

const routes = {
  '/apps/updates': createLandingPageRoute('zb no service', {
    doesRequireServerApp: true,
    isAuthRequired: false,
  }),
  '/apps/updates/:update_id/:update_slug': createLandingPageRoute(
    'zb no service',
    {
      doesRequireServerApp: true,
      isAuthRequired: false,
    }
  ),
  '/apps/categories/:categorySlug': createLandingPageRoute('zb category page', {
    doesRequireServerApp: true,
    isAuthRequired: false,
    mapDocumentToProps: mapDocumentToAppPickerProps,
    ServerWrapper: ZapbookContainer,
  }),
  '/apps': createLandingPageRoute('zb no service', {
    doesRequireServerApp: true,
    isAuthRequired: false,
    mapDocumentToProps: mapDocumentToAppPickerProps,
    ServerWrapper: ZapbookContainer,
  }),
};

export default routes;
